import { render, staticRenderFns } from "./PopConfirm.vue?vue&type=template&id=4a47e877&lang=pug"
import script from "./PopConfirm.vue?vue&type=script&lang=js"
export * from "./PopConfirm.vue?vue&type=script&lang=js"
import style0 from "./PopConfirm.vue?vue&type=style&index=0&id=4a47e877&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports